<template>
    <div class="poster">
        <div class="title">
            <p>违规监控</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item v-if="activeName > 3">
                        <el-input v-model="formInline.id" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="请输入经销商名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.phone" placeholder="请输入姓名/电话" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="敏感词" name="0">
                        <div slot="label">
                            <el-badge :value="sensitive_words" :hidden="sensitive_words <= 0" class="item"> 敏感词 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="授权取消" name="1">
                        <div slot="label">
                            <el-badge :value="authorization_cancel" :hidden="authorization_cancel <= 0" class="item"> 授权取消 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="授权过期" name="2">
                        <div slot="label">
                            <el-badge :value="authorization_overdue" :hidden="authorization_overdue <= 0" class="item"> 授权过期 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="暂停授权" name="3">
                        <div slot="label">
                            <el-badge :value="suspend_authorization" :hidden="suspend_authorization <= 0" class="item"> 暂停授权 </el-badge>
                        </div>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="虚假宣传" name="4"></el-tab-pane>
                    <el-tab-pane label="虚假销售" name="5"></el-tab-pane>-->
                    <el-tab-pane label="违规销售" name="6">
                        <div slot="label">
                            <el-badge :value="illegal_sell" :hidden="illegal_sell <= 0" class="item"> 违规销售 </el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="违规串货" name="7">
                        <div slot="label">
                            <el-badge :value="illegal_area" :hidden="illegal_area <= 0" class="item"> 违规串货 </el-badge>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="illegal_sell_id" label="编号ID" align="center" width="80px" v-if="activeName == 6"> </el-table-column>
                    <el-table-column prop="illegal_area_id" label="编号ID" align="center" width="80px" v-else-if="activeName == 7"> </el-table-column>
                    <el-table-column prop="id" label="编号ID" align="center" width="80px" v-else> </el-table-column>
                    <el-table-column prop="extra" label="监控类型" align="center" width="140px" v-if="activeName == 6 || activeName == 7">
                        <template slot-scope="scope">
                            <div class="dot">
                                <el-badge is-dot class="item" :hidden="scope.row.is_read == 1">{{ scope.row.extra }}</el-badge>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="type" label="监控类型" align="center" width="140px" v-else>
                        <template slot-scope="scope">
                            <div class="dot">
                                <el-badge is-dot class="item" :hidden="scope.row.is_read == 1">{{ tabs[activeName] }}</el-badge>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="经销商名称" align="center" > </el-table-column>
                    <el-table-column prop="principals_name" label="负责人姓名" align="center" > </el-table-column>
                    <el-table-column prop="principals_phone" label="负责人电话" align="center" > </el-table-column>
                    <el-table-column prop="level" label="经销级别" align="center" width="120px">
                        <template slot-scope="scope">
                            <p>{{ scope.row.level == 1 ? "一级" : scope.row.level == 2 ? "二级" : "三级" }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="监控时间" align="center" > </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right" >
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="detail(scope.row)">详情</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <!-- 详情 -->
        <Detail ref="refDetail"></Detail>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import Detail from "@/components/Modules/Common/Detail.vue";
export default {
    components: {
        Detail,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            selType: 1,
            tableData: [],
            formInline: {
                id: "",
                name: "",
                phone: "",
            },
            activeName: "0",
            type: "",
            tabs: ["敏感词", "授权取消", "授权过期", "暂停授权"],
            sensitive_words: 0, //敏感词未读数
            authorization_cancel: 0, //授权取消未读数
            authorization_overdue: 0, //授权过期未读数
            suspend_authorization: 0, //暂停授权未读数
            illegal_sell: 0, // 违规销售
            illegal_area: 0, // 违规串货
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
        this.getCount();
    },
    methods: {
        ...mapActions({
            getSensitiveWordList: "brand/getSensitiveWordList", //  敏感词列表
            getAuthorizationList: "brand/getAuthorizationList", //  授权列表
            getunread: "brand/getunread", //未读数
            getIllegalArea: "brand/getIllegalArea", //违规串货列表
            getSellList: "brand/getSellList", //违规销售列表
        }),
        getCount() {
            let params = {
                token: this.getToken,
                name: "violation_monitoring",
            };
            this.getunread(params).then(({ data }) => {
                if (data.code == 1) {
                    this.sensitive_words = data.data.sensitive_words;
                    this.authorization_cancel = data.data.authorization_cancel;
                    this.authorization_overdue = data.data.authorization_overdue;
                    this.suspend_authorization = data.data.suspend_authorization;
                    this.illegal_sell = data.data.illegal_sell;
                    this.illegal_area = data.data.illegal_area;
                }
            });
        },
        detail(row) {
            if (row.is_read == 0) {
                row.is_read = 1;
                switch (Number(this.activeName)) {
                    case 0:
                        this.sensitive_words -= 1;
                        break;
                    case 1:
                        this.authorization_cancel -= 1;
                        break;
                    case 2:
                        this.authorization_overdue -= 1;
                        break;
                    case 3:
                        this.suspend_authorization -= 1;
                        break;
                    case 6:
                        this.illegal_sell -= 1;
                        break;
                    case 7:
                        this.illegal_area -= 1;
                        break;
                    default:
                        break;
                }
            }
            let id = this.activeName == 6 ? row.illegal_sell_id : this.activeName == 7 ? row.illegal_area_id : row.id;
            this.$refs.refDetail.dialogVisible = true;
            this.$refs.refDetail.getDetail(id, this.activeName);
        },
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
                agency_name: this.formInline.name,
                keyword: this.formInline.phone,
            };
            let url;
            switch (Number(this.activeName)) {
                case 0:
                    url = this.getSensitiveWordList;
                    break;
                case 1:
                    opt.type = this.activeName;
                    url = this.getAuthorizationList;
                    break;
                case 2:
                    opt.type = this.activeName;
                    url = this.getAuthorizationList;
                    break;
                case 3:
                    opt.type = this.activeName;
                    url = this.getAuthorizationList;
                    break;
                case 6:
                    opt.id = this.formInline.id;
                    url = this.getSellList;
                    break;
                case 7:
                    opt.id = this.formInline.id;
                    url = this.getIllegalArea;
                    break;
                default:
                    break;
            }
            url(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                id: "",
                name: "",
                phone: "",
            };
            this.getList(1);
        },
        handleClick() {
            // console.log(this.activeName);
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__item {
        padding: 0 30px;
    }

    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.dot {
    ::v-deep .el-badge__content.is-dot {
        left: -24px;
        top: 10px;
    }
}

.tabs {
    ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: -10px;
    }
}
</style>